import { isDefined } from '@sgme/fp';
import { FormattedNumber } from 'react-intl';

type RenderPercentProps = {
  value?: Nullable<number>;
  e2e?: string;
};
export function RenderPercent({ value, e2e }: RenderPercentProps) {
  return (
    <>
      {isDefined(value) ? (
        <FormattedNumber
          value={Number(value) * 100}
          maximumFractionDigits={2}
          minimumFractionDigits={2}
          data-e2e={e2e}
        />
      ) : (
        <span data-e2e={e2e}>-</span>
      )}
      <span>&nbsp;%</span>
    </>
  );
}
